import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  accent?: 'primary' | 'cards';
  actions?: ReactNode;
  meta?: ReactNode;
  className?: string;
}

/** Contexto da rota, separado do header global persistente. */
export function PageHeader({
  title,
  subtitle,
  accent = 'primary',
  actions,
  meta,
  className,
}: PageHeaderProps) {
  return (
    <div
      data-testid="page-header"
      className={cn(
        'flex min-w-0 flex-col gap-3 sm:flex-row sm:items-end sm:justify-between',
        className,
      )}
    >
      <div className="min-w-0">
        <div className="flex min-w-0 items-center gap-3">
          <span
            aria-hidden
            className={cn(
              'hidden h-8 w-1 shrink-0 rounded-full sm:block',
              accent === 'cards' ? 'bg-cards' : 'bg-primary',
            )}
          />
          <div className="min-w-0">
            <h1 className="truncate text-[1.75rem] font-semibold leading-tight tracking-[-0.02em] text-ink lg:text-[1.875rem]">
              {title}
            </h1>
            {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
          </div>
        </div>
        {meta && <div className="mt-2 sm:ml-4">{meta}</div>}
      </div>
      {actions && (
        <div className="flex min-w-0 shrink-0 items-center gap-2 self-stretch sm:self-auto">
          {actions}
        </div>
      )}
    </div>
  );
}
